/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jan 03 2025
 **/

import useNetworkWhiteboardStore from "../stores/useNetworkWhiteboardStore";

import img_default_profile_32x32 from "@/assets/images/img_default_profile_32x32.png";
import { OwnerInfoStyle } from "./emotion";

export default function OwnerInfo() {
	const ownerInfo = useNetworkWhiteboardStore((state) => state.ownerInfo);

	const imagePath = ownerInfo?.profile == undefined ? img_default_profile_32x32 : ownerInfo.profile;
	return (
		<div css={OwnerInfoStyle}>
			{ownerInfo && (
				<>
					<div style={{ color: "#fff" }}>{ownerInfo.name}</div>
					<img
						style={{
							width: "25px",
							height: "25px",
							borderRadius: "50%"
						}}
						alt="profile-image"
						src={imagePath}
					/>
				</>
			)}
		</div>
	);
}
